"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobStatus = exports.QuoteStatus = void 0;
var QuoteStatus;
(function (QuoteStatus) {
    QuoteStatus["DRAFT"] = "DRAFT";
    QuoteStatus["PENDING"] = "PENDING";
    QuoteStatus["CHANGES_REQUESTED"] = "CHANGES_REQUESTED";
    QuoteStatus["ACCEPTED"] = "ACCEPTED";
    QuoteStatus["REJECTED"] = "REJECTED";
    QuoteStatus["INSTANT_JOB"] = "INSTANT_JOB";
    QuoteStatus["VARIATION_JOB"] = "VARIATION_JOB";
    QuoteStatus["SCHEDULED_JOB"] = "SCHEDULED_JOB";
    QuoteStatus["DELETED"] = "DELETED";
})(QuoteStatus || (exports.QuoteStatus = QuoteStatus = {}));
var JobStatus;
(function (JobStatus) {
    JobStatus["INSTANT"] = "INSTANT";
    JobStatus["TO_SCHEDULE"] = "TO_SCHEDULE";
    JobStatus["SCHEDULED"] = "SCHEDULED";
    JobStatus["IN_PROGRESS"] = "IN_PROGRESS";
    JobStatus["DONE"] = "DONE";
})(JobStatus || (exports.JobStatus = JobStatus = {}));
